import { render, staticRenderFns } from "./tms.vue?vue&type=template&id=3a1206cc&scoped=true&"
import script from "./tms.vue?vue&type=script&lang=js&"
export * from "./tms.vue?vue&type=script&lang=js&"
import style0 from "./tms.vue?vue&type=style&index=0&id=3a1206cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1206cc",
  null
  
)

export default component.exports